import {
  Box,
  Card,
  CrudMode,
  DataDisplay,
  Grid,
  pn,
  Stack,
  Typography,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Select } from "components";
import { LkRole, User, UserEditResource, UserViewResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const UserRole = (props: {
  crudMode: CrudMode;
  user: User;
  setUser: (value: User) => void;
  viewResource: UserViewResource;
  editResource: UserEditResource;
  validationErrors: ValidationErrors | string[];
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const userRoleField = () => {
    var propertyName = pn<User>("roleId");
    var property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.user.role?.name}</DataDisplay>
    ) : (
      <Select
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.editResource.roles?.find((x) => x.id === props.user.roleId)}
        options={props.editResource.roles}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setUser(
            produce(props.user, (draft) => {
              draft.roleId = value?.id;
            })
          )
        }
        renderOption={(props, option) => (
          <Box component="li" {...props}>
            <Stack>
              <Box>{option.name}</Box>
              <Typography variant="caption">{option.description}</Typography>
            </Stack>
          </Box>
        )}
      />
    );
  };

  return (
    <Card header={"Role"} fullHeight>
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={smallFieldBreakpoints}>
          {userRoleField()}
        </Grid>
      </Grid>
    </Card>
  );
};
